import React from "react";

const RTDLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 46"
    fill="none"
    style={{ color: "#CE0E2D", width: "48px", height: "auto", display: "block" }}
  >
    <path
      fill="currentColor"
      d="m18.7 26.449 19.212 19.21H31.81L16.925 30.777h-6.122V45.66H6.485V26.449h12.216Zm8.959-10.675c0 4.7-3.827 8.526-8.526 8.526H6.476V6.826h12.657c4.62-.01 8.526 4.091 8.526 8.948Zm-4.317 0c0-2.424-2.002-4.641-4.21-4.641h-8.34v8.84h8.34c2.316 0 4.21-1.884 4.21-4.2Zm22.694-8.958V45.66h-5.072L21.487 26.184c4.76-1.08 8.32-5.338 8.32-10.42 0-3.63-1.775-6.917-4.444-8.958h20.673v.01Zm-4.317 4.317h-8.31c.47 1.472.726 3.032.726 4.64 0 4.632-2.11 8.782-5.416 11.53l13 13v-29.17Zm35.842 28.051h-9.979V6.816h9.979c8.654 0 15.963 7.506 15.963 16.395 0 8.81-7.162 15.973-15.963 15.973Zm-5.662-4.317h5.652c6.427 0 11.646-5.23 11.646-11.646 0-6.554-5.337-12.078-11.646-12.078H71.9v23.724ZM93.496 7.198C89.227 2.773 83.565.34 77.56.34H0v45.32h4.317V4.657h73.244c4.827 0 9.38 1.972 12.833 5.534 3.415 3.532 5.299 8.163 5.299 13.02 0 9.998-8.134 18.122-18.122 18.122H65.434V6.806h-17.24V45.65h4.318V11.123h8.605V45.65H77.57c12.372 0 22.439-10.067 22.439-22.439-.01-5.985-2.316-11.676-6.515-16.013Z"
    />
  </svg>
);

export default RTDLogo;
